import { useEffect } from "react";

import { Gallery } from "../components/sections/Gallery";

export function GalleryPage() {
  // Land at the top when arriving from an in-page scroll position.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <Gallery />
    </main>
  );
}
